import { render, staticRenderFns } from "./LandingPageCategorySection.vue?vue&type=template&id=37c22840&"
import script from "./LandingPageCategorySection.vue?vue&type=script&lang=js&"
export * from "./LandingPageCategorySection.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageCategorySection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports